/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
// eslint-disable-next-line import/no-unresolved
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { onChangeIndianCurrency } from "src/helpers/FormDetails";
import { loanDetailsProductWise } from "src/helpers/FormDetails/resources";
import CustomReviewField from "../../../../../shared/CustomReviewField";
import CustomLabel from "../../../../../shared/CustomLabel";

function PlanReview() {
  const loanDetails = useAppSelector((state) => state.loanDetails);
  const productId = useAppSelector((state) => state.common?.productId)!;
  const planReviewMefFelds = useAppSelector(
    (state) => state.masterdata_reducer?.mefJourneySchema?.loanDetails
  );
  console.log("loanDetails", loanDetails.loan.lifeAssuredShareOfLoan);
  return (
    <div>
      {/* <div className="flex justify-between mt-8">
        <div className="text-base font-bold">Plan Details</div>
      </div> */}
      <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 md:gap-x-28 gap-x-3 mt-6 max-sm:ml-4 ">
        {(loanDetails.loan.lifeCoverOption || planReviewMefFelds?.loanCoverOption?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.loanCoverOption?.label}</CustomLabel>
            <CustomReviewField>{loanDetails.loan.lifeCoverOption || "-"}</CustomReviewField>
          </div>
        )}

        {(loanDetails.loan.loanType || planReviewMefFelds?.loanType?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.loanType?.label}</CustomLabel>
            <CustomReviewField>{loanDetails.loan.loanType || "-"}</CustomReviewField>
          </div>
        )}

        {(loanDetails.loan.loanAcNo || planReviewMefFelds?.loanAccountNo?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.loanAccountNo?.label}</CustomLabel>
            <CustomReviewField>{loanDetails.loan.loanAcNo || "-"}</CustomReviewField>
          </div>
        )}

        {(loanDetails.loan.interestPeriod || planReviewMefFelds?.interestAccruals?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.interestAccruals?.label}</CustomLabel>
            <CustomReviewField>{loanDetails.loan.interestPeriod || "-"}</CustomReviewField>
          </div>
        )}

        {(loanDetails.loan.moratoriumPeriodWith ||
          planReviewMefFelds?.moratoriumPeriod?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.moratoriumPeriod?.label}</CustomLabel>
            <CustomReviewField>
              {loanDetails.loan.moratoriumPeriodWith ?? "-"} Months
            </CustomReviewField>
          </div>
        )}

        {(loanDetails.loan.emiAmount || planReviewMefFelds?.emiAmount?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.emiAmount?.label}</CustomLabel>
            <CustomReviewField>
              {(loanDetails.loan.emiAmount &&
                `₹${onChangeIndianCurrency(loanDetails.loan.emiAmount)}`) ||
                "-"}
            </CustomReviewField>
          </div>
        )}
        {(loanDetails.loan.lifeAssuredShareOfLoan ||
          planReviewMefFelds?.lifeAssuredShareOfLoan?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.lifeAssuredShareOfLoan?.label}</CustomLabel>
            <CustomReviewField>{loanDetails.loan.lifeAssuredShareOfLoan || "-"}</CustomReviewField>
          </div>
        )}

        {(loanDetails.loan.loanTerm || planReviewMefFelds?.term?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.term?.label}</CustomLabel>
            <CustomReviewField>
              {loanDetails.loan.loanTerm || "-"} {loanDetailsProductWise[productId]?.term}
            </CustomReviewField>
          </div>
        )}

        {(loanDetails.loan.loanAmount || planReviewMefFelds?.loanAmount?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.loanAmount?.label}</CustomLabel>
            <CustomReviewField>
              ₹ {onChangeIndianCurrency(loanDetails.loan.loanAmount || "-")}
            </CustomReviewField>
          </div>
        )}

        {(loanDetails.loan.noOfCoBorrowers || planReviewMefFelds?.noOfCoBorrowers?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.noOfCoBorrowers?.label}</CustomLabel>
            <CustomReviewField>{loanDetails.loan.noOfCoBorrowers ?? "-"}</CustomReviewField>
          </div>
        )}

        {/* {(loanDetails.loan.share || planReviewMefFelds?.shareofLoan?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.shareofLoan?.label}</CustomLabel>
            <CustomReviewField>{loanDetails.loan.share || "-"} %</CustomReviewField>
          </div>
        )} */}

        {(loanDetails.loan.loanInterestRate || planReviewMefFelds?.loanInterestRate?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.loanInterestRate?.label}</CustomLabel>
            <CustomReviewField>
              {loanDetails.loan.loanInterestRate ? `${loanDetails.loan.loanInterestRate}%` : "-"}
            </CustomReviewField>
          </div>
        )}

        {(loanDetails.loan.dateOfDisbursement || planReviewMefFelds?.disbursementDate?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.disbursementDate?.label}</CustomLabel>
            <CustomReviewField>{loanDetails.loan.dateOfDisbursement || "-"}</CustomReviewField>
          </div>
        )}

        {(loanDetails.loan.lipAccNo || planReviewMefFelds?.lipAccountNo?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planReviewMefFelds?.lipAccountNo?.label}</CustomLabel>
            <CustomReviewField>{loanDetails.loan.lipAccNo || "-"}</CustomReviewField>
          </div>
        )}
      </div>
    </div>
  );
}
export default PlanReview;
